export class FilterEstimationModel {  
  estimationDescription?: string;
}
